var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.user.isCoach)?_c('profile-coach'):_vm._e(),_vm._v(" "),(_vm.user.isStudent)?_c('profile-student'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }